import { useConnect } from '@lore/query-connect';

export default function useClaims(state, network, schoolStart, schoolEnd, extra = {}) {
  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          // ...offer_networkId(network),
          offer: {
            $where: {
              creator: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          request: { $not: 'Outreach' },
          ...extra
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });
}
